(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (() => {
    const wrapper = document.querySelector('.header-wrapper--flagship');
    if (!wrapper) return;

    const header = wrapper.querySelector('.header--flagship') || wrapper;
    const mq = window.matchMedia('(min-width: 990px)');
    const hoverEnabled = (wrapper.getAttribute('data-flagship-hover') || 'false') === 'true';

    const bindSearchFocus = () => {
      const searchDetails = wrapper.querySelector('.header__search details');
      if (!searchDetails || searchDetails.dataset.fsSearchBound === '1') return;

      searchDetails.dataset.fsSearchBound = '1';

      searchDetails.addEventListener('toggle', () => {
        if (!searchDetails.open) return;

        requestAnimationFrame(() => {
          const input = wrapper.querySelector('.search-modal__content input[type="search"], .search-modal input[type="search"]');
          if (input) input.focus();
        });
      });
    };

    const clamp01 = (v) => Math.max(0, Math.min(1, v));

    const updateScrollVars = () => {
      const y = window.scrollY || 0;
      const lift = clamp01(y / 160);
      wrapper.style.setProperty('--fs-scroll', lift.toFixed(3));

      const doc = document.documentElement;
      const max = Math.max(1, doc.scrollHeight - doc.clientHeight);
      const prog = clamp01(y / max);
      wrapper.style.setProperty('--fs-progress', prog.toFixed(4));
    };

    updateScrollVars();
    window.addEventListener('scroll', updateScrollVars, { passive: true });

    try {
      const current = (window.location.pathname || '/').replace(/\/+$/, '') || '/';

      header.querySelectorAll('a.list-menu__item--link').forEach((a) => {
        const href = a.getAttribute('href');
        if (!href) return;
        if (href.indexOf('/') !== 0) return;

        const target = href.replace(/\/+$/, '') || '/';
        if (target === current) a.classList.add('is-active', 'list-menu__item--active');
      });
    } catch (e) {}

    const closeAllHeaderDropdowns = () => {
      const menu = wrapper.querySelector('.header__inline-menu');
      if (menu) {
        menu.querySelectorAll('details[open]').forEach((d) => d.removeAttribute('open'));
      }

      wrapper.querySelectorAll('.flagship-actions[open]').forEach((d) => d.removeAttribute('open'));
      wrapper.querySelectorAll('.header__search details[open]').forEach((d) => d.removeAttribute('open'));
    };

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      closeAllHeaderDropdowns();
    });

    document.addEventListener(
      'pointerdown',
      (e) => {
        if (!mq.matches) return;
        if (wrapper.contains(e.target)) return;
        closeAllHeaderDropdowns();
      },
      { passive: true }
    );

    const bindHoverOpen = () => {
      if (!hoverEnabled) return;
      const menu = wrapper.querySelector('.header__inline-menu');
      if (!menu) return;

      const items = Array.from(menu.querySelectorAll('details')).filter((d) =>
        d.querySelector('summary.list-menu__item')
      );

      if (!items.length) return;

      items.forEach((d) => {
        if (d.dataset.fsHover === '1') return;
        d.dataset.fsHover = '1';

        let tOpen = null;
        let tClose = null;

        const openNow = () => {
          items.forEach((o) => {
            if (o !== d) o.removeAttribute('open');
          });
          d.setAttribute('open', '');
        };

        const closeNow = () => d.removeAttribute('open');

        d.addEventListener('mouseenter', () => {
          if (tClose) window.clearTimeout(tClose);
          tClose = null;
          tOpen = window.setTimeout(openNow, 120);
        });

        d.addEventListener('mouseleave', () => {
          if (tOpen) window.clearTimeout(tOpen);
          tOpen = null;
          tClose = window.setTimeout(closeNow, 220);
        });
      });
    };

    const init = () => {
      if (mq.matches) bindHoverOpen();
    };

    init();
    bindSearchFocus();

    if (mq.addEventListener) {
      mq.addEventListener('change', () => init());
    } else if (mq.addListener) {
      mq.addListener(() => init());
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
